/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <MapHeader {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { MapHeader as MapHeaderModule } from "@bw/modules"

const MapHeader = ({ title }) => {
  return <MapHeaderModule title={title} />
}

export { MapHeader }
